import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=28ac6635&scoped=true&"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=js&"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=js&"
import style0 from "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=28ac6635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac6635",
  null
  
)

export default component.exports